// A toggle to enable the parallax effect
let enabled = true;
// Find the graphic
const graphic = document.querySelector('.js-banner-graphic');
// Observe the graphic to see when it is in the viewport
const Observer = new IntersectionObserver(entries => {
  enabled = entries[0].isIntersecting;
}, {
  rootMargin: '50% 0px 50% 0px'
});

// Observe the graphic
Observer.observe(graphic);

// When the user scrolls, if the graphic is in view, move it
window.addEventListener('scroll', () => {
  if (enabled) graphic.style.transform = `translateY(${Math.round(-window.scrollY * 0.2)}px)`;
}, {
  passive: true
});